// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2Kxin","activeHandle":"RangeSlider_activeHandle__12hZX","invisibleHandle":"RangeSlider_invisibleHandle__JPUA7"};